import { defineStore } from "pinia";
import { useGlobalStore } from "./global";
import { useRoute } from "vue-router";
import _ from "lodash";

const route = useRoute();

export const useShopifyStore = defineStore("shopify", {
	state: () => {
		return {
			cart: {},
			cartLoading: false,
			collections: [],
			homepageHeroSlides: [],
			homepageFeaturedCollections: [],
			homepageFeaturedProducts: [],
			homepageSubCollections: [],
			teamsCollections: [],
			instagramPosts: [],
			headerCtaCard: null,
			policies: [],
			shop: {},
			shopLoaded: false,
			search: {
				query: "",
				results: [],
				loading: false,
				debounced: null,
				debouncedTimeout: 500,
			},
		};
	},
	getters: {
		cartItems() {
			return this.cart.products || [];
		},
		cartItemCount() {
			return this.cart.totalQuantity || 0;
		},
		cartTotal() {
			return this.cart.cost?.total || "$0.00";
		},
		cartSubtotal() {
			return this.cart.cost?.subtotal || "$0.00";
		},
		isCartEmpty() {
			return this.cartItems.length === 0;
		},
	},
	actions: {
		setup() {
			this.getCart();
			this.getCollections();
			this.getPolicies();
			this.getShop();
			// Setup Search
			this.search.debounced = _.debounce(() => {
				if (this.search.query.trim()) {
					this.performSearch();
				}
			}, this.search.debouncedTimeout);
		},
		// Get Collections
		getCollections() {
			return axios
				.get("/api/shopify/collections")
				.then((collections) => {
					this.collections = collections.data;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		// Get Policies
		getPolicies() {
			return axios
				.get("/api/shopify/policies")
				.then((policies) => {
					this.policies = policies.data;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		// Get Shop
		getShop() {
			return axios
				.get("/api/shopify/shop")
				.then((shop) => {
					this.shop = shop.data;
					this.homepageHeroSlides = shop.data.homepage_hero_slides || [];
					this.homepageFeaturedCollections =
						shop.data.homepage_collections || [];
					this.homepageFeaturedProducts =
						shop.data.homepage_products || [];
					this.homepageSubCollections =
						shop.data.homepage_sub_collections || [];
					this.teamsCollections = shop.data.teams_collections || [];
					this.instagramPosts = shop.data.instagram_posts || [];
					this.headerCtaCard = shop.data.header_cta_card || null;
				})
				.catch((error) => {
					console.error(error);
				})
				.finally(() => {
					this.shopLoaded = true;
				});
		},
		// Set Search Query
		setSearchQuery(query) {
			this.search.loading = true;
			this.search.query = query;
			if (this.search.request?.cancel) {
				this.search.request.cancel();
			}
			if (query.trim()) {
				this.search.debounced();
			} else {
				this.search.results = [];
				this.search.loading = false;
			}
		},
		// Perform Search
		performSearch() {
			this.search.loading = true;
			this.search.results = [];
			axios
				.post("/api/shopify/search", {
					query: this.search.query,
				})
				.then((p) => {
					this.search.loading = false;
					this.search.results = p.data;
				})
				.catch((e) => {
					console.error(e);
					this.search.loading = false;
					this.search.results = [];
				});
		},
		//
		getCart() {
			// if(cookies.isKey('shopify')) {
			this.cartLoading = true;
			axios
				.get("/api/shopify/cart")
				.then((cart) => {
					this.cartLoading = false;
					this.cart = cart.data;
				})
				.catch((error) => {
					throw error;
				});
			// }
		},
		addToCart(variant) {
			const global = useGlobalStore();
			global.cart = true;
			this.cartLoading = true;
			return axios
				.post("/api/shopify/cart", {
					variantId: variant.id,
					quantity: variant.quantity ?? 1,
				})
				.then((cart) => {
					this.cart = cart.data;
					this.cartLoading = false;
				})
				.catch((error) => {
					throw error;
				});
		},
		updateCart(cartItem) {
			this.cartLoading = true;
			return axios
				.post("/api/shopify/cart/update", {
					id: cartItem.id,
					quantity: cartItem.quantity ?? 1,
				})
				.then((cart) => {
					this.cart = cart.data;
					this.cartLoading = false;
					return cart.data;
				})
				.catch((error) => {
					throw error;
				});
		},
		removeFromCart(cartItemId) {
			this.cartLoading = true;
			return axios
				.post("/api/shopify/cart/update", {
					id: cartItemId,
					quantity: 0,
				})
				.then((cart) => {
					this.cart = cart.data;
					this.cartLoading = false;
					return cart.data;
				})
				.catch((error) => {
					throw error;
				});
		},
	},
});
